import { render, staticRenderFns } from "./matchdetail.vue?vue&type=template&id=500e6d93"
import script from "./matchdetail.vue?vue&type=script&lang=js"
export * from "./matchdetail.vue?vue&type=script&lang=js"
import style0 from "./matchdetail.vue?vue&type=style&index=0&id=500e6d93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports